import { useEffect, useRef, useState } from "react";
import {
  Button,
  Dropdown,
  DropdownButton,
  Form,
  InputGroup,
  Modal,
} from "react-bootstrap";
import { NEW_API_URL } from "../../../constants/Globals";
import axios from "axios";
import { addStepToSequence } from "../../../services/CollectionsSvc";
import CustomColorPicker from "../CustomColorPicker";

const AddEditProductModal = ({
  show = true,
  onClose,
  productId,
  sequenceId,
  orderNumber,
  match,
  selNetworkId,
}) => {
  const hexColorRegex = /^#([0-9A-F]{3}){1,2}$/i;
  // console.log('productId.....', productId);
  // const [searchProductLink, setSearchProductLink] = useState("");
  const [title, setTitle] = useState("");
  const [titleColor, setTitleColor] = useState("#000000");
  const [titleFontSize, setTitleFontSize] = useState("16px");

  const [description, setDescription] = useState("");
  const [descriptionColor, setDescriptionColor] = useState("#000000");
  const [descriptionFontSize, setDescriptionFontSize] = useState("16px");

  const [price, setPrice] = useState("");
  const [priceColor, setPriceColor] = useState("#000000");
  const [priceFontSize, setPriceFontSize] = useState("16px");

  const [buttonText, setButtonText] = useState("");
  const [buttonTextColor, setButtonTextColor] = useState("#000000");
  const [buttonFontSize, setButtonFontSize] = useState("16px");
  const [buttonColor, setButtonColor] = useState("#000000");

  const [linkToNextStep, setLinkToNextStep] = useState(false);
  const [productLink, setProductLink] = useState("");
  const [backgroundColor, setBackgroundColor] = useState("#000000");

  const [productImage, setProductImage] = useState(null);
  const [couponButtonText, setCouponButtonText] = useState("");
  const [couponButtonTextColor, setCouponButtonTextColor] = useState("#000000");
  const [couponButtonFontSize, setCouponButtonFontSize] = useState("16px");
  const [couponButtonColor, setCouponButtonColor] = useState("#000000");
  const [couponButtonCopyValue, setCouponButtonCopyValue] = useState("");

  const productImgFileInputRef = useRef();

  // const handleSelect = (selected) => {
  //   setTitleFontSize(selected);
  // };

  const handleCheckboxChange = (e) => {
    setLinkToNextStep(e.target.checked); // Updates state when the checkbox is toggled
  };

  //-- to get pixel list
  const pxOptions = Array.from({ length: 30 }, (_, i) => `${i + 1}px`);
  const renderPxDropdown = (id, onSelectCallback) => (
    <DropdownButton
      variant="outline-secondary"
      title=""
      id={id}
      align="end"
      onSelect={(selected) => onSelectCallback(selected)}
    >
      {pxOptions.map((option) => (
        <Dropdown.Item key={option} eventKey={option}>
          {option}
        </Dropdown.Item>
      ))}
    </DropdownButton>
  );

  const kTrans = (str) => str;
  // useEffect(() => {
  //     alert(`Color changed to: ${backgroundColor}`);
  // }, [backgroundColor]);
  useEffect(() => {
    if (productId > 0) fetchContentProductById();
  }, [productId]);

  const fetchContentProductById = async () => {
    try {
      const response = await axios.get(`${NEW_API_URL}/product/${productId}`);
      // console.log("Response from server:", response.data);
      if (response.data) {
        const data = response.data.data;
        setTitle(data.title);
        setDescription(data.description);
        setPrice(data.price);
        setButtonText(data.buttonText);
        setProductLink(data.productLink);
        setTitleColor(data.styleTitle.color);
        setTitleFontSize(data.styleTitle.fontSize);
        setDescriptionColor(data.styleDescription.color);
        setDescriptionFontSize(data.styleDescription.fontSize);
        setPriceColor(data.stylePrice.color);
        setPriceFontSize(data.stylePrice.fontSize);
        setButtonTextColor(data.styleButton.textColor);
        setButtonFontSize(data.styleButton.fontSize);
        setButtonColor(data.styleButton.color);
        setLinkToNextStep(data.linkToNextStep);
        setBackgroundColor(data.styleBackground.color);
        setCouponButtonText(data.couponButtonText);
        setCouponButtonTextColor(data.styleCouponButton.textColor);
        setCouponButtonFontSize(data.styleCouponButton.fontSize);
        setCouponButtonColor(data.styleCouponButton.color);
        setCouponButtonCopyValue(data.styleCouponButton.copyValue);
        if (data.productImage) {
          setProductImage(data.productImage);
        }
      }
    } catch (error) {
      console.error("Error fetching content call to action by ID:", error);
    }
  };

  const handleProductImageUploadClick = () => {
    productImgFileInputRef.current.click();
  };
  const handleProductImageFileChange = (e) => {
    const productFileObj = e.target.files[0];
    if (productFileObj) {
      // console.log('Image file detail:', productFileObj, URL.createObjectURL(productFileObj));
      // setCtaImage(URL.createObjectURL(productFileObj)); // for preview
      uploadImageToS3(productFileObj);
    }
  };

  // const getProductCrawlDetail = async () => {
  //   try {
  //     console.log('Product link search req:::', searchProductLink);
  //     if (searchProductLink.trim() === "") {
  //       alert("Please enter a product link to fetch details.");
  //       return false;
  //     }
  //     const response = await axios.get(`${NEW_API_URL}/product-crwle/detail?searchUrl=${searchProductLink}`);
  //     console.log("Response from server:", response.data);
  //     if (response.status && response.data) {
  //       const data = response.data.data;
  //       setTitle(data.title ? data.title : "");
  //       setDescription(data.description ? data.description : "");
  //       setPrice(data.price ? data.price.toString() : "");
  //       setProductLink(searchProductLink);
  //       if (data.imgUrl) {
  //         setProductImage(data.imgUrl);
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Error fetching content call to action by ID:", error);
  //   }
  // }

  const uploadImageToS3 = async (fileObj) => {
    const formData = new FormData();
    formData.append("productFile", fileObj);
    formData.append("key", fileObj.name);

    try {
      const response = await axios.post(
        `${NEW_API_URL}/product/upload-image`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      // console.log("Image uploaded successfully:", response.data);
      if (response.data) {
        setProductImage(response.data.data);
      } else {
        console.error("Image upload failed:", response.data);
        alert("Error in file upload.");
        return false;
      }
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };

  function isValidUrl(value) {
    try {
      const url = new URL(value);
      return url.protocol === "http:" || url.protocol === "https:";
    } catch (err) {
      return false;
    }
  }

  function validateInputs() {
    if (title.trim() === "") {
      alert("Please enter product title.");
      return false;
    }
    if (description.trim() === "") {
      alert("Please enter product description.");
      return false;
    }
    if (price.trim() === "") {
      alert("Please enter product price.");
      return false;
    }
    if (buttonText.trim() === "") {
      alert("Please enter product button text.");
      return false;
    }
    if (!linkToNextStep && productLink.trim() === "") {
      alert("Please enter product button link.");
      return false;
    }

    if (productLink && !isValidUrl(productLink)) {
      alert("Product link not valid.");
      return false;
    }

    if (hexColorRegex.test(titleColor) == false) {
      alert("Title color is not valid.");
      return false;
    }
    if (hexColorRegex.test(descriptionColor) == false) {
      alert("Description color is not valid.");
      return false;
    }
    if (hexColorRegex.test(priceColor) == false) {
      alert("Price color is not valid.");
      return false;
    }
    if (hexColorRegex.test(buttonTextColor) == false) {
      alert("Button text color is not valid.");
      return false;
    }
    if (hexColorRegex.test(buttonColor) == false) {
      alert("Button color is not valid.");
      return false;
    }
    if (hexColorRegex.test(backgroundColor) == false) {
      alert("Background color is not valid.");
      return false;
    }
    if (hexColorRegex.test(couponButtonTextColor) == false) {
      alert("Coupon button text color is not valid.");
      return false;
    }
    if (hexColorRegex.test(couponButtonColor) == false) {
      alert("Coupon button color is not valid.");
      return false;
    }
    return true;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    const isValid = validateInputs();
    if (!isValid) {
      return false;
    }
    try {
      let closeModelAf = 1;
      let productRecId = null;
      const url =
        productId > 0
          ? `${NEW_API_URL}/product/${productId}`
          : `${NEW_API_URL}/product`;
      const method = productId > 0 ? "PUT" : "POST";
      let nextId = null;

      await axios
        .request({
          url,
          method,
          data: {
            // id: id,
            title: title,
            styleTitle: { color: titleColor, fontSize: titleFontSize },
            description: description,
            styleDescription: {
              color: descriptionColor,
              fontSize: descriptionFontSize,
            },
            price: price,
            stylePrice: { color: priceColor, fontSize: priceFontSize },
            buttonText: buttonText,
            styleButton: {
              color: buttonColor,
              fontSize: buttonFontSize,
              textColor: buttonTextColor,
            },
            linkToNextStep: linkToNextStep,
            productLink: productLink,
            productImage: productImage,
            styleBackground: { color: backgroundColor },
            couponButtonText: couponButtonText,
            styleCouponButton: {
              color: couponButtonColor,
              fontSize: couponButtonFontSize,
              textColor: couponButtonTextColor,
              copyValue: couponButtonCopyValue,
            },
          },
        })
        .then(({ data }) => {
          const response = data;
          productRecId = response.data;
          // console.log("Response from server:", response);
          // if (data.status == 1) {
          //     onClose(true);
          // }
        });
      if (productRecId && !productId) {
        try {
          const payload = {
            sequenceId: sequenceId,
            order: orderNumber + 1,
            isBranch: false,
            partType: "product",
            partId: productRecId,
          };

          const response = await addStepToSequence(payload);
          nextId = response.data.data;
        } catch (error) {
          closeModelAf = 0;
          console.error(
            "Failed to add step to sequence due to step part:",
            error
          );
          alert(
            "Failed to add step to sequence due to step part. Please try again."
          );
        }
      }
      if (closeModelAf == 1) {
        onClose(nextId);
      }
    } catch (error) {
      console.error("Error in saving product:", error);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      size="lg"
      dialogClassName="w-100"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {productId > 0 ? "Edit Product" : "Add a Product"}{" "}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* <Form className="common-form sided-form"> */}
        {/* <div style={{ display: "flex", gap: "1rem", marginBottom: "1rem" }}>
            <Form.Group className="" style={{ flex: 1 }}>
              <Form.Label>
                <b className="fs-6">
                  {kTrans("Insert a product link to pre-fill the form below")}
                </b>
              </Form.Label>
              <Form.Control
                type="text"
                value={searchProductLink}
                onChange={(e) => {
                  setSearchProductLink(e.target.value);
                }}
                id="searchProductLink"
                name="searchProductLink"
                className="w-100"
                placeholder={kTrans("Enter product URL")}
              />
            </Form.Group>
            <Form.Group className="" style={{ flex: 1 }}>
              <Form.Label>
                <b className="text-sm-start">{kTrans("")}&nbsp;</b>
              </Form.Label>
              <InputGroup className="w-5">
                <button type="submit" className="w-30 blue-button" onClick={getProductCrawlDetail} >
                  Get Product Details
                </button>
              </InputGroup>
            </Form.Group>
          </div> */}
        {/* </Form> */}
        <Form onSubmit={handleSubmit} className="common-form sided-form">
          <div
            style={{ display: "flex", gap: "1rem", marginBottom: "1rem" }}
          ></div>
          {/* Title fields */}
          <div style={{ display: "flex", gap: "1rem", marginBottom: "1rem" }}>
            <Form.Group className="" style={{ flex: 4 }}>
              <Form.Label>
                <b className="text-sm-start">{kTrans("Product title")}</b>
              </Form.Label>
              <Form.Control
                type="text"
                value={title}
                onChange={(e) => {
                  setTitle(e.target.value);
                }}
                id="title"
                name="title"
                className="w-100"
                placeholder={kTrans("Add a title")}
                // style={{ width: '100px', height: '40px', padding: '0' }}
              />
            </Form.Group>
            <Form.Group className="" style={{ flex: 1 }}>
              <Form.Label>
                <b className="text-sm-start">{kTrans("")}&nbsp;</b>
              </Form.Label>
              <InputGroup className="w-100 color-picker-container">
                <CustomColorPicker
                  color={titleColor}
                  onChange={(newColor) => setTitleColor(newColor)}
                />
                <Form.Control
                  type="text"
                  value={titleColor}
                  onChange={(e) => {
                    setTitleColor(e.target.value);
                  }}
                  id="titleColour"
                  name="titleColour"
                  className="w-30"
                  style={{ border: "0px" }}
                />
              </InputGroup>
            </Form.Group>
            <Form.Group className="" style={{ flex: 1 }}>
              <Form.Label>
                <b className="text-sm-start">{kTrans("")}&nbsp;</b>
              </Form.Label>
              <DropdownButton
                className="customDropdown w-30 standard-dropdown"
                id="titleFontSize"
                title={
                  pxOptions.find((item) => item === titleFontSize) ?? "N/A"
                }
              >
                {pxOptions.map((option, i) => (
                  <Dropdown.Item
                    key={option}
                    eventKey={option}
                    onClick={(e) => setTitleFontSize(option)}
                  >
                    {option}
                  </Dropdown.Item>
                ))}
              </DropdownButton>
              {/* <InputGroup className="w-5">
                                    <Form.Control
                                    type="text"
                                    value={titleFontSize}
                                    onChange={(e) => {
                                    setTitleFontSize(e.target.value);
                                    }}
                                    id="titleFontSize"
                                    name="titleFontSize"
                                    className="w-10"
                                    readOnly
                                    />
                                    {renderPxDropdown("pxdropdown1", setTitleFontSize)}
                                </InputGroup> */}
            </Form.Group>
          </div>

          {/* Description fields */}
          <div style={{ display: "flex", gap: "1rem", marginBottom: "1rem" }}>
            <Form.Group className="" style={{ flex: 4 }}>
              <Form.Label>
                <b className="text-sm-start">{kTrans("Product Description")}</b>
              </Form.Label>
              <Form.Control
                type="text"
                value={description}
                onChange={(e) => {
                  setDescription(e.target.value);
                }}
                id="description"
                name="description"
                className="w-100"
                placeholder={kTrans("Enter a description")}
              />
            </Form.Group>
            <Form.Group className="" style={{ flex: 1 }}>
              <Form.Label>
                <b className="text-sm-start">{kTrans("")}&nbsp;</b>
              </Form.Label>
              <InputGroup className="w-100 color-picker-container">
                <CustomColorPicker
                  color={descriptionColor}
                  onChange={(newColor) => setDescriptionColor(newColor)}
                />

                <Form.Control
                  type="text"
                  value={descriptionColor}
                  style={{ border: "0px" }}
                  onChange={(e) => {
                    setDescriptionColor(e.target.value);
                  }}
                />
              </InputGroup>
            </Form.Group>
            <Form.Group className="" style={{ flex: 1 }}>
              <Form.Label>
                <b className="text-sm-start">{kTrans("")}&nbsp;</b>
              </Form.Label>
              <DropdownButton
                className="customDropdown w-30 standard-dropdown"
                id="descriptionFontSize"
                title={
                  pxOptions.find((item) => item === descriptionFontSize) ??
                  "N/A"
                }
              >
                {pxOptions.map((option, i) => (
                  <Dropdown.Item
                    key={option}
                    eventKey={option}
                    onClick={(e) => setDescriptionFontSize(option)}
                  >
                    {option}
                  </Dropdown.Item>
                ))}
              </DropdownButton>
            </Form.Group>
          </div>
          {/* Price fields */}
          <div style={{ display: "flex", gap: "1rem", marginBottom: "1rem" }}>
            <Form.Group className="" style={{ flex: 4 }}>
              <Form.Label>
                <b className="text-sm-start">{kTrans("Product Price")}</b>
              </Form.Label>
              <Form.Control
                type="text"
                value={price}
                onChange={(e) => {
                  setPrice(e.target.value);
                }}
                id="price"
                name="price"
                className="w-100"
                placeholder={kTrans("Enter price")}
              />
            </Form.Group>
            <Form.Group className="" style={{ flex: 1 }}>
              <Form.Label>
                <b className="text-sm-start">{kTrans("")}&nbsp;</b>
              </Form.Label>
              <InputGroup className="w-100 color-picker-container">
                <CustomColorPicker
                  color={priceColor}
                  onChange={(newColor) => setPriceColor(newColor)}
                />
                <Form.Control
                  type="text"
                  value={priceColor}
                  style={{ border: "0px" }}
                  onChange={(e) => {
                    setPriceColor(e.target.value);
                  }}
                />
              </InputGroup>
            </Form.Group>
            <Form.Group className="" style={{ flex: 1 }}>
              <Form.Label>
                <b className="text-sm-start">{kTrans("")}&nbsp;</b>
              </Form.Label>
              <DropdownButton
                className="customDropdown w-30 standard-dropdown"
                id="responseCountTarget"
                title={
                  pxOptions.find((item) => item === priceFontSize) ?? "N/A"
                }
              >
                {pxOptions.map((option, i) => (
                  <Dropdown.Item
                    key={option}
                    eventKey={option}
                    onClick={(e) => setPriceFontSize(option)}
                  >
                    {option}
                  </Dropdown.Item>
                ))}
              </DropdownButton>
              {/* <InputGroup className="w-5">
                                    <Form.Control
                                    type="text"
                                    value={priceFontSize}
                                    onChange={(e) => {
                                    setPriceFontSize(e.target.value);
                                    }}
                                    id="priceFontSize"
                                    name="priceFontSize"
                                    className="w-10"
                                    />
                                    {renderPxDropdown("pxdropdown2", setPriceFontSize)}
                                </InputGroup> */}
            </Form.Group>
          </div>
          {/* Button text fields */}
          <div style={{ display: "flex", gap: "1rem", marginBottom: "1rem" }}>
            <Form.Group className="" style={{ flex: 4 }}>
              <Form.Label>
                <b className="text-sm-start">{kTrans("Button Text")}</b>
              </Form.Label>
              <Form.Control
                type="text"
                value={buttonText}
                onChange={(e) => {
                  setButtonText(e.target.value);
                }}
                id="buttonText"
                name="buttonText"
                className="w-100"
                placeholder={kTrans("Enter button text")}
              />
            </Form.Group>
            <Form.Group className="" style={{ flex: 1 }}>
              <Form.Label>
                <b className="text-sm-start">{kTrans("")}&nbsp;</b>
              </Form.Label>
              <InputGroup className="w-100 color-picker-container">
                <CustomColorPicker
                  color={buttonTextColor}
                  onChange={(newColor) => setButtonTextColor(newColor)}
                />

                <Form.Control
                  type="text"
                  value={buttonTextColor}
                  style={{ border: "0px" }}
                  onChange={(e) => {
                    setButtonTextColor(e.target.value);
                  }}
                />
              </InputGroup>
            </Form.Group>
            <Form.Group className="" style={{ flex: 1 }}>
              <Form.Label>
                <b className="text-sm-start">{kTrans("")}&nbsp;</b>
              </Form.Label>
              <DropdownButton
                className="customDropdown w-30 standard-dropdown"
                id="responseCountTarget"
                title={
                  pxOptions.find((item) => item === buttonFontSize) ?? "N/A"
                }
              >
                {pxOptions.map((option, i) => (
                  <Dropdown.Item
                    key={option}
                    eventKey={option}
                    onClick={(e) => setButtonFontSize(option)}
                  >
                    {option}
                  </Dropdown.Item>
                ))}
              </DropdownButton>
            </Form.Group>
          </div>
          {/* Button link fields */}
          <div style={{ display: "flex", gap: "1rem", marginBottom: "1rem" }}>
            <Form.Group className="" style={{ flex: 4 }}>
              <div className="d-flex justify-content-between align-items-center">
                <Form.Label className="mb-0 w-50">
                  <b className="text-sm-start">{kTrans("Product Link")}</b>
                </Form.Label>
                <div className="w-50 d-flex justify-content-end align-items-center">
                  <Form.Label>
                    <span className="text-muted me-2 text form-label text-font">
                      {kTrans("Link to next step")}
                    </span>
                  </Form.Label>
                  <Form.Check.Input
                    className="toggle-checkbox small"
                    style={{ margin: "5px 15px" }}
                    checked={!!linkToNextStep}
                    onChange={handleCheckboxChange}
                    name="linkToNextStep"
                    value={linkToNextStep}
                    data-type="Link to next step"
                  />
                </div>
              </div>
              <Form.Control
                type="text"
                value={productLink}
                onChange={(e) => {
                  setProductLink(e.target.value);
                }}
                id="productLink"
                name="productLink"
                className="w-100"
                placeholder={kTrans("Enter product link")}
              />
            </Form.Group>
            <Form.Group className="" style={{ flex: 1 }}>
              <Form.Label>
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    margin: "3px 0px",
                  }}
                >
                  <b className="text-sm-start">
                    {kTrans("Button Color")}&nbsp;
                  </b>
                </span>
              </Form.Label>
              <InputGroup className="w-100 color-picker-container">
                <CustomColorPicker
                  color={buttonColor}
                  onChange={(newColor) => setButtonColor(newColor)}
                />

                <Form.Control
                  type="text"
                  value={buttonColor}
                  style={{ border: "0px" }}
                  onChange={(e) => {
                    setButtonColor(e.target.value);
                  }}
                />
              </InputGroup>
            </Form.Group>
            <div style={{ flex: 1 }}></div>
          </div>
          {/* Coupon code Button text fields */}
          <div style={{ display: "flex", gap: "1rem", marginBottom: "1rem" }}>
            <Form.Group className="" style={{ flex: 4 }}>
              <Form.Label>
                <b className="text-sm-start">{kTrans("Coupon Code Button Text")}</b>
              </Form.Label>
              <Form.Control
                type="text"
                value={couponButtonText}
                onChange={(e) => {
                  setCouponButtonText(e.target.value);
                }}
                id="buttonText"
                name="buttonText"
                className="w-100"
                placeholder={kTrans("Enter coupon code button text")}
              />
            </Form.Group>
            <Form.Group className="" style={{ flex: 1 }}>
              <Form.Label>
                <b className="text-sm-start">{kTrans("")}&nbsp;</b>
              </Form.Label>
              <InputGroup className="w-100 color-picker-container">
                <CustomColorPicker
                  color={couponButtonTextColor}
                  onChange={(newColor) => setCouponButtonTextColor(newColor)}
                />

                <Form.Control
                  type="text"
                  value={couponButtonTextColor}
                  style={{ border: "0px" }}
                  onChange={(e) => {
                    setCouponButtonTextColor(e.target.value);
                  }}
                />
              </InputGroup>
            </Form.Group>
            <Form.Group className="" style={{ flex: 1 }}>
              <Form.Label>
                <b className="text-sm-start">{kTrans("")}&nbsp;</b>
              </Form.Label>
              <DropdownButton
                className="customDropdown w-30 standard-dropdown"
                id="responseCountTarget"
                title={
                  pxOptions.find((item) => item === couponButtonFontSize) ?? "N/A"
                }
              >
                {pxOptions.map((option, i) => (
                  <Dropdown.Item
                    key={option}
                    eventKey={option}
                    onClick={(e) => setCouponButtonFontSize(option)}
                  >
                    {option}
                  </Dropdown.Item>
                ))}
              </DropdownButton>
            </Form.Group>
          </div>
          {/* Image fields */}
          <div
            className="d-flex justify-content-start align-items-center flex-row"
            style={{ marginBottom: "2rem" }}
          >
            <Form.Group className="">
              <Form.Label>
                <b className="text-sm-start">{kTrans("Product Image")}&nbsp;</b>
              </Form.Label>
              <Button
                variant="outline-primary"
                size="md"
                onClick={handleProductImageUploadClick}
              >
                {productImage ? "Uploaded" : "Upload Image"}
              </Button>
              <Form.Control
                type="file"
                accept="image/*"
                ref={productImgFileInputRef}
                onChange={handleProductImageFileChange}
                style={{ display: "none" }} // hide actual file input
              />
            </Form.Group>
            <Form.Group className="ms-4">
              <Form.Label>
                <b className="text-sm-start">
                  {kTrans("Background Color")}&nbsp;
                </b>
              </Form.Label>
              <InputGroup className="w-5 color-picker-container">
                <CustomColorPicker
                  color={backgroundColor}
                  onChange={(newColor) => setBackgroundColor(newColor)}
                />

                <Form.Control
                  type="text"
                  value={backgroundColor}
                  style={{ border: "0px" }}
                  onChange={(e) => {
                    setBackgroundColor(e.target.value);
                  }}
                />
              </InputGroup>
            </Form.Group>
            <Form.Group className="ms-4">
              <Form.Label>
                <b className="text-sm-start">
                  {kTrans("Coupon Button Color")}&nbsp;
                </b>
              </Form.Label>
              <InputGroup className="w-5 color-picker-container">
                <CustomColorPicker
                  color={couponButtonColor}
                  onChange={(newColor) => setCouponButtonColor(newColor)}
                />

                <Form.Control
                  type="text"
                  value={couponButtonColor}
                  style={{ border: "0px" }}
                  onChange={(e) => {
                    setCouponButtonColor(e.target.value);
                  }}
                />
              </InputGroup>
            </Form.Group>
            <Form.Group className="ms-4">
              <Form.Label>{kTrans("Coupon Button Copy Value")}&nbsp;</Form.Label>
              <Form.Control
                type="text"
                value={couponButtonCopyValue}
                onChange={(e) => {
                  setCouponButtonCopyValue(e.target.value);
                }}
                id="couponButtonCopyValue"
                name="couponButtonCopyValue"
                className="w-100"
                placeholder={kTrans("Enter coupon button copy value")}
              />
            </Form.Group>
          </div>
          

          <div className="center">
            <button type="submit" className="blue-button size-l">
              Save
            </button>
          </div>
        </Form>
      </Modal.Body>
      {/* <Modal.Footer> */}
      {/* <Button variant="secondary" onClick={onClose}>Close</Button> */}
      {/* <Button variant="primary" onClick={() => alert("Confirmed!")}>Save</Button> */}
      {/* </Modal.Footer> */}
    </Modal>
  );
};

export default AddEditProductModal;
